import { render, staticRenderFns } from "./ActiveEconomyIntegration.vue?vue&type=template&id=a81904b4&scoped=true&"
import script from "./ActiveEconomyIntegration.vue?vue&type=script&lang=js&"
export * from "./ActiveEconomyIntegration.vue?vue&type=script&lang=js&"
import style0 from "./ActiveEconomyIntegration.vue?vue&type=style&index=0&id=a81904b4&lang=scss&scoped=true&"
import style1 from "./ActiveEconomyIntegration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81904b4",
  null
  
)

export default component.exports